import useFetch from 'elements/Hooks/useFetch'
import React from 'react'
import { withRouter } from 'react-router-dom'
import { get } from 'lodash'
import { isEmpty } from 'lodash'
import { pick } from 'lodash'
import useFetchObject from '../../../../elements/Hooks/useFetchObject'
import DocumentsApi from '../../../../api/Documents'
import useTitle from '../../../../elements/Hooks/useTitle'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import useSubmit from '../../../../elements/Hooks/useSubmit'
import { MODAL_TYPE_NEW } from '../../../../elements/Hooks/useModalData'
import { message } from 'antd'
import { VendorQuoteApi } from '../../../../api/Purchase/VendorQuotes'
import AddVendorQuote from '../../../../components/Purchasing/VendorQuotes/AddVendorQuote/AddVendorQuote'
import qs from 'query-string'

AddVendorQuoteCont.propTypes = {}
const formRef = React.createRef()
const docsApi = new DocumentsApi()

function AddVendorQuoteCont(props) {
  const key = get(props.match, 'params.key')
  const { rfqID, vendorID } = qs.parse(props.location.search)
  const type = key ? 'edit' : 'new'

  const { fetch: fetchVendorQuote, fetching, data: vendorQuote } = useFetch({
    url: `vendorQuotes/${key}/?select=*`,
    queryKey: `vendorQuotes/${key}`,
    dependencyArray: [key],
    dontFetch: isEmpty(key),
  })

  const { fetch: fetchLines, fetching: fetchingLines, data: lines = [] } = useFetch({
    url: `vendorQuotes/lines/${key}`, // getLinesByVendorQuotes
    dependencyArray: [vendorQuote._rev],
    dontFetch: isEmpty(key),
  })

  function fetch() {
    fetchVendorQuote()
    fetchLines()
  }

  useTitle(vendorQuote.quoteNo === undefined ? `Create New Vendor Quote` : `${vendorQuote.quoteNo} Vendor Quote`)

  const [updating, updateFunc] = useSubmit(VendorQuoteApi.update)

  function checkForm() {
    return new Promise((res, rej) => {
      formRef.current.validateFieldsAndScroll((err, values) => {
        if (!err) {
          res(values)
        } else rej(err)
      })
    })
  }

  const [submitting, submitFunc] = useSubmit(VendorQuoteApi.create)

  async function submit() {
    const values = await checkForm()
    const submitted = await submitFunc(values)
    fetch()
    if (submitted)
      props.history.push({
        pathname: `/purchasing/vendor/quotes/${submitted._key}/update`,
      })
  }

  async function update() {
    const values = await checkForm()
    const vendorQuoteDB = await updateFunc({
      ...pick(vendorQuote, ['_key', '_id', '_rev']),
      ...values,
    })
    fetch()
    if (vendorQuoteDB) fetchVendorQuote()
  }

  const [removing, removeFunc] = useSubmit(VendorQuoteApi.remove)

  async function remove() {
    const removed = await removeFunc({
      ...pick(vendorQuote, ['_key', '_rev', '_id']),
    })
    fetch()
    if (removed)
      props.history.replace({
        pathname: `/purchasing/vendor/quotes/`,
      })
  }

  const { list: actions, fetching: fetchingActions, fetch: fetchActions } = useFetchList(
    () => docsApi.actions('vendorQuotes', vendorQuote.status),
    [vendorQuote.status, isEmpty(vendorQuote.status)]
  )
  const isNew = type === MODAL_TYPE_NEW
  const isUpdatable = actions.find((a) => a.key === 'update')
  const [submittingOperation, submitOperation] = useSubmit(VendorQuoteApi.operation)

  async function handleActions(operation) {
    let hide = message.loading('', 0)
    const vqdb = await submitOperation({
      status: operation,
      ...pick(vendorQuote, ['_key', '_rev', '_id']),
    })
    if (vqdb) fetchVendorQuote()

    hide()
  }

  const isConfirmed = ['Confirmed'].includes(vendorQuote.status)

  const [createQuote, submitQuoteFunc] = useSubmit(VendorQuoteApi.createQuote)

  async function submitQuote() {
    let hide = message.loading('', 0)
    const submitted = await submitQuoteFunc(vendorQuote._key)
    if (submitted)
      props.history.push({
        pathname: `/clients/quotes/${submitted._key}/update`,
      })
    hide()
  }

  return (
    <AddVendorQuote
      {...{
        isUpdatable,
        isConfirmed,
        fetching,
        submitting,
        updating,
        fetch,
        vendorQuote,
        submit,
        removing,
        remove,
        update,
        type,
        formRef,
        actions,
        fetchingActions,
        fetchActions,
        handleActions,
        isNew,
        rfqID,
        vendorID,
        lines,
        fetchingLines,
        submitQuote,
      }}
    />
  )
}

export default withRouter(AddVendorQuoteCont)
